import React, { Component } from 'react';

import Loading from '../Loading/Loading';

// Import Style
import './NoData.scss';


export default class NoData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };
  }

  render() {
    if (this.props.loading) {
      return (
        <div className={`no_data ${this.props.className}`}>
          <h3>{this.props.title}</h3>
          <div className='loader-delay'>
            <Loading />
          </div>
        </div>
      );
    }

    if (!this.props.loading && this.props.show) {
      return (
        <div className={`no_data ${this.props.className}`}>
          <h3>{this.props.title}</h3>
          <p> No data available </p>
        </div>
      );
    }

    return null;
  }
}
